// src/pages/Retreats.jsx
import React, { useEffect } from 'react';
import Navbar from '../common/Navbar';
import Footer from '../common/Footer';
import { Link } from 'react-router-dom';

// Import all images
import cardiologyImg from '../assets/A-image14.png';
import hyperImg from '../assets/A-image15.png';
import lipidImg from '../assets/A-image16.png';
import rehabImg from '../assets/A-image16.png';
import arjunaImg from '../assets/A-image16.png';
import stressImg from '../assets/A-image8.png';
import detoxImg from '../assets/A-image7.png';

import CardiologyPreventive from '../components/retreats/CardiologyPreventive';



const Retreats = () => {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <div className="min-h-screen bg-[#F8F3EA]">
      <Navbar />

      <main>
        <CardiologyPreventive />
        
      </main>

      <Footer />
    </div>
  );
};

export default Retreats;